module.exports = __webpack_public_path__ + "img/bay_room.4dac5626.jpg";